export default __webpack_public_path__ + "static/male4-a5e1ac2d762835f5951b27f5f488c978.png";